// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7100c07b","453":"0dc13b3d","455":"70b7052f"}[chunkId] + ".chunk.js";
};